import type { FC } from "react";
import { useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";

import PrinterIcon from "images/icons/printer-blue.svg";

import { generateImagePDF } from "utils/generateImagePDF";

interface Props {
  printAttachmentURL: string;
  pdfName?: string;
}

const PrintAttachmentBox: FC<Props> = ({ printAttachmentURL, pdfName }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleButtonClick = () => {
    setIsGenerating(true);
    generateImagePDF([printAttachmentURL], pdfName)
      .catch(console.error)
      .finally(() => {
        setIsGenerating(false);
      });
  };

  return (
    <Alert variant="info">
      <div>
        {/* TODO: translate */}
        <strong>Řeš na papír</strong>
      </div>
      <Button variant="link" className="p-0" onClick={handleButtonClick} disabled={isGenerating}>
        {isGenerating ? (
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className={"me-2"} />
        ) : (
          <PrinterIcon />
        )}{" "}
        Stáhni a vytiskni si arch
      </Button>
    </Alert>
  );
};

export default PrintAttachmentBox;
